export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-telephone-4e9da521de0d131e51e146bef356ff29.svg";